<div class="wrapper">
  <div *ngIf="(customerPendingState$ | async) === pendingState.success">
    <div *ngIf="environment.backToShopLink && !isGreaterThanExtraSmall()" class="back-link-container">
      <a class="back-on-mobile mat-h2 back-link" href="{{ environment!.backToShopLink }}">
        <mat-icon class="back-link-icon top-zero">shopping_cart</mat-icon>
        {{ 'GENERAL.BACK_TO_SHOP' | translate }}</a
      >
    </div>
    <ng-container *ngIf="environment.customer === ciceroCustomerName; else defaultView">
      <div class="confinement">
        <div>
          <mat-card class="clickable-card mat-elevation-z2" (click)="navigate('/navigation/account/address')">
            <div class="icon-container">
              <mat-icon class="dashboard-icon">home</mat-icon>
            </div>
            <div class="center-dashboard-text">
              <mat-card-title>
                {{ 'DASHBOARD.ADDRESS_TITLE' | translate }}
              </mat-card-title>
              <mat-card-content>
                <div class="dashboard-links mat-body-1">
                  {{ 'DASHBOARD.ADDRESS_DESCRIPTION' | translate }}
                </div>
              </mat-card-content>
            </div>
          </mat-card>
        </div>
        <div (click)="navigate('/navigation/orders/dashboard')">
          <mat-card class="clickable-card mat-elevation-z2">
            <div class="icon-container">
              <mat-icon class="dashboard-icon">list_alt</mat-icon>
            </div>
            <div class="center-dashboard-text">
              <mat-card-title>
                {{ 'DASHBOARD.ORDERS_TITLE' | translate }}
              </mat-card-title>
              <mat-card-content>
                {{ 'DASHBOARD.ORDERS_DESCRIPTION' | translate }}
              </mat-card-content>
            </div>
          </mat-card>
        </div>
        <div (click)="navigate('/navigation/account/payment-methods')">
          <mat-card class="clickable-card mat-elevation-z2">
            <div class="icon-container">
              <mat-icon class="dashboard-icon">credit_card</mat-icon>
            </div>
            <div class="center-dashboard-text">
              <mat-card-title>
                {{ 'DASHBOARD.PAYMENT_METHODS_TITLE' | translate }}
              </mat-card-title>
              <mat-card-content>
                {{ 'DASHBOARD.PAYMENT_METHODS_DESCRIPTION' | translate }}
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; gap: 2rem; margin: 5rem auto 2rem; justify-content: center">
        <div
          (click)="changePassword()"
          (keydown)="changePassword()"
          class="button-area mat-elevation-z2"
          style="padding: 1rem"
        >
          <mat-icon style="margin-right: 1rem">key</mat-icon>
          <span gdArea="content">Passwort ändern</span>
        </div>

        <div
          gdArea="online-subscriptions"
          (click)="redirectToOnlineSubscriptions()"
          *ngIf="environment.onlineSubscriptionLink"
          class="primary-color-text button-area mat-elevation-z2"
          style="padding: 1rem"
        >
          <mat-icon style="margin-right: 1rem">article</mat-icon>
          <span gdArea="content"> zum Cicero E-Paper </span>
        </div>
      </div>
    </ng-container>

    <ng-template #defaultView>
      <div class="confinement">
        @let userProfile = userProfile$ | async; @if (userProfile?.c4sessionId) {
        <mat-card class="clickable-card mat-elevation-z2" (click)="navigate('/navigation/account/address')">
          <div class="icon-container"><mat-icon class="dashboard-icon">home</mat-icon></div>
          <div class="center-dashboard-text">
            <mat-card-title>{{ 'DASHBOARD.ADDRESS_TITLE' | translate }}</mat-card-title>
            <mat-card-content>
              {{ 'DASHBOARD.ADDRESS_DESCRIPTION' | translate }}
            </mat-card-content>
          </div>
        </mat-card>
        <mat-card class="clickable-card mat-elevation-z2" (click)="navigate('/navigation/orders/dashboard')">
          <div class="icon-container"><mat-icon class="dashboard-icon">list_alt</mat-icon></div>
          <div class="center-dashboard-text">
            <mat-card-title>{{ 'DASHBOARD.ORDERS_TITLE' | translate }}</mat-card-title>
            <mat-card-content>
              {{ 'DASHBOARD.ORDERS_DESCRIPTION' | translate }}
            </mat-card-content>
          </div>
        </mat-card>
        @if (environment.features.paymentMethods) {
        <mat-card class="clickable-card mat-elevation-z2" (click)="navigate('/navigation/account/payment-methods')">
          <div class="icon-container"><mat-icon class="dashboard-icon">credit_card</mat-icon></div>
          <div class="center-dashboard-text">
            <mat-card-title>{{ 'DASHBOARD.PAYMENT_METHODS_TITLE' | translate }}</mat-card-title>
            <mat-card-content>
              {{ 'DASHBOARD.PAYMENT_METHODS_DESCRIPTION' | translate }}
            </mat-card-content>
          </div>
        </mat-card>
        } @if (showPasswordReset) {
        <mat-card class="clickable-card mat-elevation-z2" (click)="changePassword()">
          <div class="icon-container"><mat-icon class="dashboard-icon">key</mat-icon></div>
          <div class="center-dashboard-text">
            <mat-card-title>{{ 'DASHBOARD.CHANGE_CREDENTIALS_TITLE' | translate }}</mat-card-title>
            <mat-card-content>
              {{ 'DASHBOARD.CHANGE_CREDENTIALS_DESCRIPTION' | translate }}
            </mat-card-content>
          </div>
        </mat-card>
        } } @if (userProfile?.isGroupAdmin) {
        <mat-card class="clickable-card mat-elevation-z2" (click)="navigate('/navigation/groups')">
          <div class="icon-container"><mat-icon class="dashboard-icon">lan</mat-icon></div>
          <div class="center-dashboard-text">
            <mat-card-title>{{ 'DASHBOARD.GROUPS_TITLE' | translate }}</mat-card-title>
            <mat-card-content>{{ 'DASHBOARD.GROUPS_DESCRIPTION' | translate }}</mat-card-content>
          </div>
        </mat-card>
        }
        <mat-card
          *ngIf="environment.onlineSubscriptionLink || environment.digitalContent"
          class="clickable-card mat-elevation-z2"
          (click)="redirectToOnlineSubscriptions()"
        >
          <div class="icon-container"><mat-icon class="dashboard-icon">article</mat-icon></div>
          <div class="center-dashboard-text">
            <mat-card-title>{{ 'DASHBOARD.ONLINE_SUBSCRIPTIONS_TITLE' | translate }}</mat-card-title>
            <mat-card-content>
              {{ 'DASHBOARD.ONLINE_SUBSCRIPTIONS_DESCRIPTION' | translate }}
            </mat-card-content>
          </div>
        </mat-card>
        <mat-card
          *ngIf="environment.onlineSubscriptionLink && environment.digitalContent"
          class="clickable-card primary-color-text mat-elevation-z2"
          (click)="redirectToExternalWebReader()"
        >
          <div class="icon-container"><mat-icon class="dashboard-icon">article</mat-icon></div>
          <div class="center-dashboard-text">
            <mat-card-title>{{ 'DASHBOARD.WEB_READER_TITLE' | translate }}</mat-card-title>
            <mat-card-content>
              {{ 'DASHBOARD.WEB_READER_DESCRIPTION' | translate }}
            </mat-card-content>
          </div>
        </mat-card>
      </div>
    </ng-template>
  </div>

  <div class="spinner" *ngIf="(customerPendingState$ | async) === pendingState.pending">
    <mat-spinner></mat-spinner>
  </div>

  <div *ngIf="(customerPendingState$ | async) === pendingState.failed" class="wrapper">
    <mat-card class="content-box confinement">
      <mat-card-title class="error-text">
        {{ 'ERROR.TITLE' | translate }}
      </mat-card-title>
      <mat-card-content class="error-text">
        {{ 'ERROR.DESCRIPTION' | translate }}
      </mat-card-content>
    </mat-card>
  </div>
</div>
